import { render, staticRenderFns } from "./PopupOK.vue?vue&type=template&id=3ba92c91&"
import script from "./PopupOK.vue?vue&type=script&lang=js&"
export * from "./PopupOK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports